/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMinus: {
  name: 'minus';
  data: string;
} = {
  name: 'minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 8a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></svg>`,
};
